module.exports = __webpack_public_path__ + "img/circle-01.8af7749e.svg";